import { TCity, TCountry, TExpertiseItem, TProfession, TState } from '@onesource/schemas';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ProDirectoryPreview } from './pro-directory-preview';
import { TProFormValues } from './steps';

type Props = {
  countries: TCountry[];
  states: TState[];
  cities: TCity[];
  professions: TProfession[];
  expertiseItems: TExpertiseItem[];
};

export const ProDirectoryStepPreview: FC<Props> = props => {
  const { control } = useFormContext<TProFormValues>();
  const values = useWatch({ control });

  return <ProDirectoryPreview values={values as Partial<TProFormValues>} {...props} />;
};
